export enum ECalendarName {
	Outside,
	Timeblock,
	Reminders,
	Free
}
